import { Component, OnInit, OnChanges, Input, Output, EventEmitter, } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';

import { OwnerService } from '../../../service/owner/owner.service';
import { ShelfService } from '../../../service/shelf/shelf.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { validation } from '../../../util/validation';
import { config } from '../../../util/config';

@Component({
  selector: 'wa9242',
  templateUrl: 'wa9242.component.html',
  styleUrls: ['wa9242.component.scss']
})
export class Wa9242Component implements OnInit {
  public componentTitle = 'WA9242:格納什器マスタ修正';

  public working = false;
  public containerHeight = 500;
  public production = environment.production;
  public backgroundColor: string;

  // for error message
  public validation = validation;
  // Define each input element (initial value and validation rule)
  public shelfCd = new FormControl('', [
      Validators.required,
      Validators.pattern(validation.halfBlankOnly),
      Validators.pattern(validation.code39),
      Validators.maxLength(validation.shelfCd.maxLength)
    ]);
  public shelfTx = new FormControl('', [
    Validators.required,
    Validators.pattern(validation.allBlankOnly),
    Validators.maxLength(validation.shelfTx.maxLength)
    ]);

  public stockshelfFl = 0;
  public shipshelfFl = 0;
  // build FormGroup

  private errorInfo = '';

  @Input() isShow = false;
  @Output() closeButtonClick = new EventEmitter<boolean>();
  private isDelayHide = true;

  private isSubmitButtonEnabled = false;

  readonly STRINGS_ACTIVE = 'active';
  readonly STRINGS_ERROR = 'error';

  private shelfTxCls = '';
  private delisizeNrCls = '';
  private shelf = null;

  constructor(
    private router: Router,
    private builder: FormBuilder,
    private ownerService: OwnerService,
    private shelfService: ShelfService,
    private commonService: CommonService,
    private dialogsService: DialogsService
  ) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
  }

  ngOnInit() {
    setTimeout(() => {
      this.onView();
    }, 500);
  }

  onView() { }

  onSubmit() {
    this.errorInfo = '';
    if (!this.isSubmitButtonEnabled) {
      return;
    }

    const shelfCd = this.shelfCd.value.trim();

    const shelfTx = this.shelfTx.value.trim();
    let errors = false;
    if (this.shelfTx.errors !== null) {
      this.shelfTx.markAsTouched({ onlySelf: true });
      errors = true;
    }
    if (errors) {
      return;
    }
    //SW-2097　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.shelfService
      .put(shelfCd, shelfTx, 'wa9242')
      .then(outputJson => {
        this.working = false;
        this.closeButtonClick.emit(true);
      })
      .catch(error => {
        this.working = false;
        console.log(this.commonService.getErrorMessage(error));
        this.errorInfo = this.commonService.getErrorMessage(error);
      });
  }

  cancel() {
    this.closeButtonClick.emit(false);
  }

  ngOnChanges() {
    if (this.isShow) {
      this.isDelayHide = false;
      this.initDatas();
    } else {
      this.isShow = false;
      setTimeout(() => {
        this.isDelayHide = true;
      }, 300);
    }
  }

  initDatas() {
    const rowShelf: object = JSON.parse(sessionStorage.getItem('rowShelf'));
    this.shelf = rowShelf;

    this.shelfCd.setValue(rowShelf['shelfCd']);
    this.shelfTx.setValue(rowShelf['shelfTx']);

    this.isSubmitButtonEnabled = false;
    console.log(this.shelf)
  }

  ngDoCheck() {
    if (!this.isShow) {
      return;
    }
    this.shelfTxCls = (this.shelfTx.value === this.shelf['shelfTx']) ? '' :
                        ((this.shelfTx.errors == null ? this.STRINGS_ACTIVE : this.STRINGS_ERROR));
    this.checkSubmitButtonState();
  }

  checkSubmitButtonState() {
    this.isSubmitButtonEnabled = (this.shelfTxCls === this.STRINGS_ACTIVE );
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa9Master/wa9242/wa9242.component.ts